var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sf_account_info!=null && _vm.sfdcSearchEnabled && _vm.ifUserCanAccess)?_c('div',[(_vm.sf_account_info!=null && _vm.ifUserCanAccess)?_c('account-page',{attrs:{"prop_account_page_obj":_vm.sf_account_info,"prop_user_sites":_vm.userSites,"prop_user":_vm.login_user_name,"prop_user_roles":_vm.userRoles}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-968852ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/opty-management/AccountMasterPage.vue
// module id = null
// module chunks = 